const items = [
    "MOBILE MECHANIC",
    "OIL CHANGES",
    "BRAKES",
    "TUNE-UPS",
    "PRE-PURCHASE INSPECTIONS",
    "DIAGNOSTICS",
    "BATTERY & ELECTRICAL",
];

export default function Marquee() {
    const loop = [...items, ...items, ...items];
    return (
        <div
            data-testid="marquee-strip"
            className="bg-[#0a0a0a] text-white border-y hairline overflow-hidden"
        >
            <div className="flex whitespace-nowrap animate-marquee py-5 items-center">
                {loop.map((t, i) => (
                    <span
                        key={`${t}-${i}`}
                        className="flex items-center font-display text-2xl md:text-3xl mx-6 tracking-tight text-white"
                    >
                        {t}
                        <span
                            aria-hidden
                            className="inline-block w-2 h-2 bg-[#1d4ed8] mx-6"
                        />
                    </span>
                ))}
            </div>
        </div>
    );
}
